import React from 'react';
import { Route } from 'react-router-dom';
import PlacementDashboard from '@/pages/placement/PlacementDashboard';
import Companies from '@/pages/placement/Companies';
import JobPostings from '@/pages/placement/JobPostings';
import Applications from '@/pages/placement/Applications';
import PlacementReports from '@/pages/placement/PlacementReports';
import CompanyVisits from '@/pages/placement/CompanyVisits';
import StudentJobPortal from '@/pages/placement/StudentJobPortal';

export const placementRoutes = (
  <React.Fragment>
    <Route path="placement" element={<PlacementDashboard />} />
    <Route path="placement/dashboard" element={<PlacementDashboard />} />
    <Route path="placement/companies" element={<Companies />} />
    <Route path="placement/jobs" element={<JobPostings />} />
    <Route path="placement/applications" element={<Applications />} />
    <Route path="placement/reports" element={<PlacementReports />} />
    <Route path="placement/visits" element={<CompanyVisits />} />
    <Route path="placement/student-portal" element={<StudentJobPortal />} />
  </React.Fragment>
);
